/* unplugin-vue-components disabled */import { render } from "./CoveoAILoggedOut.vue?vue&type=template&id=0aa8266f"
import script from "./CoveoAILoggedOut.vue?vue&type=script&lang=js"
export * from "./CoveoAILoggedOut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__